import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/svg/calendly-confirmed.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "confirmedMeetingView" }
const _hoisted_3 = { class: "main-info" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Confirmed", -1)
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = { class: "text-info" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0,
  alt: "confirmed icon"
}, null, -1)
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "time-zone" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mail-info" }, "A calendar invitation has been sent to your email address.", -1)
const _hoisted_12 = { class: "contact-info" }
const _hoisted_13 = { class: "contact-info-list" }
const _hoisted_14 = { class: "contact-info-el" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "contact-info-el" }
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "contact-info-el" }
const _hoisted_19 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "bubble",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h2", _hoisted_5, "You are scheduled with " + _toDisplayString(_ctx.dataInfo['assigned_to']) + ".", 1),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.dataInfo['event_type_name']), 1)
            ]),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.startTime) + " - " + _toDisplayString(_ctx.endTime), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.timeZone), 1),
            _hoisted_11,
            _createVNode(_component_router_link, {
              class: "btn",
              to: "/"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Return to the main page")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("ul", _hoisted_13, [
              _createElementVNode("li", _hoisted_14, [
                _createElementVNode("a", {
                  target: "_blank",
                  href: `mailto:${_ctx.commonData['commonEmail']}`,
                  class: "contacts-link"
                }, _toDisplayString(_ctx.commonData['commonEmail']), 9, _hoisted_15)
              ]),
              _createElementVNode("li", _hoisted_16, [
                _createElementVNode("a", {
                  target: "_blank",
                  href: `tel:${_ctx.commonData['commonPhone']}`,
                  class: "contacts-link"
                }, _toDisplayString(_ctx.commonData['commonPhone']), 9, _hoisted_17)
              ]),
              _createElementVNode("li", _hoisted_18, [
                _createElementVNode("a", {
                  target: "_blank",
                  href: _ctx.commonData['commonTelegram'],
                  class: "contacts-link"
                }, "Telegram", 8, _hoisted_19)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}